<template>
  <div
    class="header-bets">
    <modal
      v-if="statisticsEnabled"
      :show="showModal"
      @modalclosed="closeModalAndLoader()"
      position="statistics-modal">
      <div slot="header">{{ getTranslation('sportsbook.statistics') }}</div>
      <iframe
        slot="body"
        v-if="showModal"
        @load="closeLoader"
        :src="generateStatLink(tournament.providerId)"/>
    </modal>
    <div
      class="tournament-wrapper"
      v-if="metaLoaded">
      <div class="flag-wrapper">
        <div :class="['flag', getFlag({tournament, category}), ]"/>
      </div>
      <div
        class="tournament-name-wrapper"
        v-if="tournament">
        {{ tournament.name }}
      </div>
      <span
        v-if="statisticsEnabled && tournament"
        class="stats-icon"
        @click="toggleModalAndLoader()">
        <i class="n-i n-i-stats"/>
      </span>
    </div>
    <div
      v-if="metaLoaded"
      class="bets-wrapper">
      <div
        class="header-bet"
        v-for="bet in bets"
        :key="bet.id">
        <div
          class="bet-name">
          {{ bet.name }}
        </div>
        <div
          class="header-outcomes"
          :class="[ 'header-outcomes-' + bet.outcomes.length ]"
          v-if="bet.outcomes">
          <div
            class="header-outcome"
            v-for="outcome in bet.outcomes.slice(0, 3)"
            :key="outcome.idBetOutcome"
          >
            {{ outcome.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Category from '../../../services/parser/Category';
import gateway from '../../../services/gravityGateway';
import Modal from '../modal/Modal.vue';

export default {
  data() {
    return {
      showLoader: false,
      actionMethod: null,
    };
  },
  components: {
    Modal,
  },
  computed: {
    showModal() {
      return this.$store.getters.getStatsModalState;
    },
    appSettings() {
      return this.$store.getters.getCompanyConfig;
    },
    bets() {
      return this.$store.getters.getBetsBySportId({ sportId: this.sport, limit: 3 }) || [];
    },
    metaLoaded() {
      return this.$store.getters.getMetaLoaded;
    },
    statisticsEnabled() {
      return this.appSettings.statistics.enabled;
    },
    company() {
      return this.$store.getters.getCompany;
    },
  },
  methods: {
    generateStatLink(tournamentId) {
      const { statistics } = this.appSettings;
      const statLink = `${statistics.link}${statistics.clientId}/${this.company.locale}/tournament/${tournamentId}`;
      return statLink;
    },
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    getFlag({ tournament, category }) {
      return `flag-${_.toLower(category.isoName || 'INT')} flag-${_.toLower((this.tournaments[tournament.parent] || {}).providerId)}`;
    },
    toggleModalAndLoader() {
      this.$store.dispatch('openStatsModal');
      this.showLoader = !this.showLoader;
    },
    closeModalAndLoader() {
      this.$store.dispatch('closeStatsModal');
      this.showLoader = false;
    },
    closeLoader() {
      this.showLoader = false;
    },
  },
  props: {
    sport: {
      type: String,
      required: true,
    },
    tournament: {
      type: Object,
      required: true,
    },
    category: {
      type: Category,
      required: true,
    },
    tournaments: {
      type: Object,
      required: true,
    },
  },
  watch: {
    showLoader(newValue) {
      gateway.sendMessage('Widget.Loading', {
        isLoading: newValue,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../scss/default/flags';

$stat-icon-size: 46px;
$stat-icon-size-wrapper: $stat-icon-size + 10px;
$flag-size: 32px;

.tournament-wrapper {
  float: left;
  width: 25%;
  display: flex;
  align-items: center;
  height: 52px;
}

.flag-wrapper {
  width: $flag-size;
  height: $flag-size;
  transform: scale(.75)
}

.tournament-name-wrapper {
  width: calc(100% - #{$stat-icon-size-wrapper} - (#{$flag-size * 0.75}));
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 5px;
}

.stats-icon {
  margin-right: 5px;
  width: $stat-icon-size;
  text-align: center;
  box-sizing: border-box;
  height: $stat-icon-size;
  line-height: $stat-icon-size;
  background: rgba(#fff, 0.05);
  align-self: flex-start;
}

.bets-wrapper {
  float: left;
  width: 70%;
}

.header-bets {
  overflow: hidden;
  clear: both;
  height: 52px;
}

.header-bet {
  float: left;
  width: 33.33%;
}

.bet-name {
  text-align: center;
  text-transform: uppercase;
  height: 26px;
  line-height: 32px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-outcomes {
  overflow: hidden;

  .header-outcome {
    float: left;
    width: 33.33%;
    text-align: center;
  }

  &-2 {
    .header-outcome {
      width: 50%;
    }
  }
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
